const API_INFO = {
    BASE_URL:
        process.env.NODE_ENV == 'development'
            ? 'http://localhost:8080/api'
            : 'https://backend.kasexpressgn.com/api',
};

export default API_INFO;
